import { Label } from '@/components/ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { T } from '@tolgee/react'
import { Field } from 'react-final-form'
import { SERVICE_TYPES } from '../../_utils/constants'

interface ServiceTypeFieldProps {
  disabled?: boolean
}

export function ServiceTypeField({ disabled = false }: ServiceTypeFieldProps) {
  return (
    <Field name='serviceType'>
      {({ input }) => (
        <div>
          <Label htmlFor={input.name} variant='dialog-field'>
            <T keyName='serviceRegistry.dialog.fields.serviceType.label' />*
          </Label>
          <Select
            name={input.name}
            value={input.value}
            onValueChange={input.onChange}
            disabled={disabled}
          >
            <SelectTrigger isDirty>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value={SERVICE_TYPES.MCP_OAUTH2}>
                <T keyName='serviceRegistry.dialog.serviceTypes.oauth' />
              </SelectItem>
              <SelectItem value={SERVICE_TYPES.MCP_KEY}>
                <T keyName='serviceRegistry.dialog.serviceTypes.apiKey' />
              </SelectItem>
            </SelectContent>
          </Select>
        </div>
      )}
    </Field>
  )
}
